<template>
  <v-data-table
    :headers="headers"
    :items="filteredItems"
    :search="search"
    sort-by="name"
    class="elevation-0"
  >
    <template v-slot:top>
      <v-toolbar flat color="transparent">
        <v-toolbar-title>MEDIA ITEM PARENT RECORDS</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-col cols="3" sm="3" md="3" class="pr-0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            dense
            outlined=""
            class="mr-0"
          ></v-text-field>
        </v-col>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }" class="text-right">
      <!--      <v-icon size="24" @click="deleteRecord(item, $event)"> mdi-close </v-icon>-->
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    mediaId: {
      required: true,
      type: Number
    }
  },
  data: () => ({
    search: '',
    headers: [
      {
        text: 'RECORD NAME',
        align: 'start',
        sortable: false,
        value: 'name'
      },
      { text: 'RECORD TYPE', value: 'type', sortable: false }
      // { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
    ],
    records: [],
    deletedRecords: []
  }),

  created() {
    this.initialize()
  },

  methods: {
    async initialize() {
      await this.$store
        .dispatch('MediaManagerStore/getMediaPois', this.mediaId)
        .then(res => {
          console.log(res)
          this.records = res.data
        })
    },
    deleteRecord(item) {
      let arr = JSON.parse(JSON.stringify(this.deletedRecords))
      let params = {
        mediaId: this.mediaId,
        poiId: item.id
      }
      arr.push(params)
      this.deletedRecords = arr
      this.$emit('deletedRecords', this.deletedRecords)
    }
  },
  computed: {
    filteredItems() {
      let deletedIds = this.deletedRecords.map(item => {
        return item.poiId
      })
      return this.records.filter(item => !deletedIds.includes(item.id))
    }
  }
}
</script>
